import { render, staticRenderFns } from "./TripListItem.vue?vue&type=template&id=cf132882&scoped=true&"
import script from "./TripListItem.vue?vue&type=script&lang=ts&"
export * from "./TripListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TripListItem.vue?vue&type=style&index=0&id=cf132882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf132882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
